// src/components/main/gallery_container.js
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Gallery from "./gallery";
import { fetchMediaForPath } from "../../actions/gallery_actions";

const mapState = (state) => ({
  items: state.gallery?.items || [],
  loading: state.gallery?.loading || false,
  error: state.gallery?.error || null,
});

const mapDispatch = (dispatch, ownProps) => ({
  fetchForCurrentPath: () =>
    dispatch(fetchMediaForPath(ownProps.location?.pathname || "/")),
});

export default withRouter(connect(mapState, mapDispatch)(Gallery));
